"use strict";
exports.__esModule = true;
var EffectTag;
(function (EffectTag) {
    EffectTag[EffectTag["Pure"] = 0] = "Pure";
    EffectTag[EffectTag["PureOption"] = 1] = "PureOption";
    EffectTag[EffectTag["PureEither"] = 2] = "PureEither";
    EffectTag[EffectTag["Raised"] = 3] = "Raised";
    EffectTag[EffectTag["Completed"] = 4] = "Completed";
    EffectTag[EffectTag["Suspended"] = 5] = "Suspended";
    EffectTag[EffectTag["Async"] = 6] = "Async";
    EffectTag[EffectTag["Chain"] = 7] = "Chain";
    EffectTag[EffectTag["Collapse"] = 8] = "Collapse";
    EffectTag[EffectTag["InterruptibleRegion"] = 9] = "InterruptibleRegion";
    EffectTag[EffectTag["AccessInterruptible"] = 10] = "AccessInterruptible";
    EffectTag[EffectTag["AccessRuntime"] = 11] = "AccessRuntime";
    EffectTag[EffectTag["AccessEnv"] = 12] = "AccessEnv";
    EffectTag[EffectTag["ProvideEnv"] = 13] = "ProvideEnv";
    EffectTag[EffectTag["Map"] = 14] = "Map";
})(EffectTag = exports.EffectTag || (exports.EffectTag = {}));
